import { isPlainObject } from '../../utils/plain-object.util';

const EMPTY_FORM_IDS = Object.freeze([]);

const isNonBlankString = (value) => typeof value === 'string' && value.trim() !== '';

/** Dedupes form ids while preserving first-seen order. */
export const dedupeFormIds = (formIds = []) => [...new Set(formIds.filter(isNonBlankString))];

const toRawFormIds = (formId) => {
  if (Array.isArray(formId)) {
    return formId;
  }
  return isNonBlankString(formId) ? [formId] : EMPTY_FORM_IDS;
};

/** Reads legacy string and current array `form_id` configurations as an ordered id list. */
export const readFormsWidgetFormIds = (config) =>
  dedupeFormIds(toRawFormIds(isPlainObject(config) ? config.form_id : null));

export const appendFormIds = (existingFormIds = [], addedFormIds = []) =>
  dedupeFormIds([...existingFormIds, ...addedFormIds]);

export const toSelectedFormIds = (selectedForms) => (selectedForms ?? []).map((form) => form?.id);

export const removeFormIdFrom = (formIds = [], formId) => formIds.filter((id) => id !== formId);

export const hasSameFormIds = (left = [], right = []) =>
  left.length === right.length && left.every((formId, index) => formId === right[index]);

/** Builds the PATCH config, persisting an empty form list as null. */
export const toFormsWidgetConfig = (formIds = []) => {
  const uniqueFormIds = dedupeFormIds(formIds ?? EMPTY_FORM_IDS);
  return { form_id: uniqueFormIds.length > 0 ? uniqueFormIds : null };
};
